import React from 'react';
import { Box, Container, Paper, Typography, TextField, Button } from '@mui/material';

const Register = () => {
  return (
    <Box sx={{ py: 6, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom>
            Register
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            This is a placeholder registration page. Replace with your real registration form.
          </Typography>
          <Box component="form" noValidate autoComplete="off" sx={{ display: 'grid', gap: 2 }}>
            <TextField label="Email" type="email" fullWidth />
            <TextField label="Password" type="password" fullWidth />
            <TextField label="Confirm Password" type="password" fullWidth />
            <Button variant="contained" size="large">Create account</Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Register;
